@for(cc of creditCards; track cc.token) {
  <equine-ui-nx-bt-credit-card-selector-item
    [cc]="cc"
    [selectedToken]="selectedItemToken"
    (click)="creditCardSelected(cc.token)"
  ></equine-ui-nx-bt-credit-card-selector-item>
}
@empty {
  <div class="m-2">You don't have saved cards.</div>
  <div class="m-2">If you want to save a card mark the checkbox when you pay with a new card.</div>
}